<template>
  <div>
    <div>
      <div v-if="loaded && adminMessages.length === 0">
        <div class="alert alert-primary" role="alert">پیامی یافت نشد.</div>
      </div>
    </div>
    <div
      v-if="loaded && adminMessages.length"
      class="card card-custom gutter-b"
    >
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>نام کاربر</th>
                <th>ایمیل</th>
                <th>موضوع</th>
                <th>متن</th>
                <th>تاریخ ثبت</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="message in adminMessages" :key="message.id">
                <td>{{ message.name }}</td>
                <td>
                  <a :href="`mailto:${message.email}`">{{ message.email }}</a>
                </td>
                <td>
                  <span>{{ message.subject }}</span>
                </td>
                <td class="text-nowrap">
                  <span class="max-w-300px">{{ message.content }}</span>
                </td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(message.created_at) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="overflow-auto mt-5" v-if="adminMessagesPagination.lastPage > 1">
      <b-pagination
        v-model="adminMessagesPagination.currentPage"
        :total-rows="adminMessagesPagination.total"
        :per-page="adminMessagesPagination.perPage"
        aria-controls="my-table"
        @input="updateMessages()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { FETCH_ADMIN_ADMINS } from "@/core/services/store/admin/messages.module";
import { mapGetters } from "vuex";

export default {
  name: "admin-messages",
  data() {
    return {
      loaded: false,
      searchType: ""
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "تماس‌با‌ما" }]);
    this.$store.dispatch(SET_ACTIONS, {});
    this.updateMessages();
  },
  computed: {
    ...mapGetters(["adminMessages", "adminMessagesPagination"])
  },
  methods: {
    updateMessages() {
      this.loaded = false;
      this.$store
        .dispatch(FETCH_ADMIN_ADMINS)
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    }
  }
};
</script>
